import { useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom-v5-compat'
import { NAV_LEFT_WRAP } from 'shared/components/Nav/NavLeft'
import { Colors } from 'shared/theme/colors'
import styled from 'styled-components'

import { useAnalyticsEvent } from '../../../hooks/useAnalyticsEvent'
import { useLogRocket } from '../../../hooks/useLogRocket'
import { logoutUser } from '../../../redux/actions/auth/authActions'
import { ReduxDispatch } from '../../../redux/store/models'
import { SIGN_IN_PATH } from '../../../Routes'
import { AppCompanyBrand } from './AppCompanyBrand'
import { AvatarMenu, AvatarMenuOptions } from './AvatarMenu'
import { brandedNavigation, NavigationActions, NavigationBrand } from './BrandedNavigation.styles'

export function VendorNav() {
  const navigate = useNavigate()
  const dispatch: ReduxDispatch = useDispatch()
  const queryClient = useQueryClient()
  const track = useAnalyticsEvent()

  useLogRocket()

  const handleLogout = () => {
    track('profile_logout_click')

    dispatch(logoutUser())
    queryClient.clear()
    navigate(SIGN_IN_PATH, { replace: true })
  }

  return (
    <NavWrap className="app-nav">
      <NavigationBrand>
        <AppCompanyBrand />
      </NavigationBrand>
      <div id={NAV_LEFT_WRAP} />
      <NavigationActions>
        <AvatarMenu handleLogout={handleLogout} options={[AvatarMenuOptions.LOGOUT]} />
      </NavigationActions>
    </NavWrap>
  )
}

const NavWrap = styled.div`
  min-height: 64px;
  background-color: ${Colors.white};
  ${brandedNavigation}
  position: relative;
  justify-content: space-between;
`
